var ikastgymnasium = ikastgymnasium || {};
( function () {
    jQuery( function () {
        ikastgymnasium.initOnReady();
    } );
    ikastgymnasium.initOnReady = function () {
        ikastgymnasium.instafeed.init();
        ikastgymnasium.lightbox.init();
    };
    ikastgymnasium.instafeed      = {
        init: function () {
            var domElmInstagram = document.getElementById( 'instagram-feed' );
            if ( domElmInstagram !== null ) {
                var cache = sessionStorage.getItem( 'instagram.cache' );
                if ( cache !== null ) {
                    ikastgymnasium.instafeed.manualBuild( domElmInstagram, JSON.parse( cache ) );
                }
                else {
                    ikastgymnasium.instafeed.build( domElmInstagram );
                }
            }
        }, 
        getTemplate: function ( boolIncludeCaption ) {
            var domStrCaptions = boolIncludeCaption ? '<div class="instagram-feed-item-caption"><p>{{caption}}</p></div>' : '',
                domStrItem     = '<div class="instagram-feed-item"><a style="background-image:url({{image}}); background-size:cover; display:block; height: 100%;" href="{{link}}" target="_blank"><img src="/Files/Templates/Designs/ikastgymnasium-e4/_assets/img/trans.png"/>' + domStrCaptions + '</a></div>';
            return domStrItem;
        },
        build: function ( domElmInstagram ) {
            var url = 'https://graph.instagram.com/me/media?fields=caption,id,media_type,media_url,permalink,thumbnail_url,timestamp,username&access_token=' + domElmInstagram.dataset.token + '&limit=' + parseInt( domElmInstagram.dataset.limit );
            jQuery.ajax( {
                url: url,
                method: 'GET'
            } ).done( function ( data ) {
                sessionStorage.setItem( 'instagram.cache', JSON.stringify( data ) );
                ikastgymnasium.instafeed.manualBuild( domElmInstagram, data );
            } );
        },
        manualBuild: function ( domElmInstagram, cache ) {
            var parser   = new DOMParser(),
                data     = cache.data,
                template = ikastgymnasium.instafeed.getTemplate(true);
            for ( var i = 0; i < parseInt( domElmInstagram.dataset.limit ); i++ ) {
                var isVideo = data[ i ].media_type === 'VIDEO',
                    item = template.replace( /{{caption}}/g, data[ i ].caption ).replace( /{{image}}/g, isVideo ? data[ i ].thumbnail_url : data[ i ].media_url ).replace( /{{link}}/g, data[ i ].permalink ),
                    doc = parser.parseFromString( item, 'text/html' ),
                    parsedItem = doc.body.firstChild;
                parsedItem.classList.add( 'instagram-feed-item-' + i );
                jQuery( domElmInstagram ).append( parsedItem );
            }
        }
    };
    
    ikastgymnasium.lightbox      = {};
    ikastgymnasium.lightbox.init = function () {
        jQuery( document ).on( 'click', '[data-toggle="lightbox"]', function ( event ) {
            event.preventDefault();
            jQuery( this ).ekkoLightbox();
        } );
    };
}() );
